"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rating = function (_a) {
    return null;
};
exports.Rating.displayName = "Rating";
